import React from 'react';
export const CFIconCode = {
    alias: 'code',
    defaultTitle: 'Code',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm16.951 5.373 4.828 6a1 1 0 0 1-.01 1.268l-5 6a.998.998 0 0 1-1.41.128 1.003 1.003 0 0 1-.127-1.41l4.477-5.37-4.316-5.362a1 1 0 0 1 1.558-1.254Zm-9.719-.014a1.001 1.001 0 0 1 1.537 1.282l-4.477 5.37 4.316 5.363a1 1 0 0 1-1.559 1.254l-4.828-6a1 1 0 0 1 .011-1.268l5-6Z' }))),
};
